import { render } from "./UsersManager.vue?vue&type=template&id=7c300492&scoped=true&lang=pug"
import script from "./UsersManager.vue?vue&type=script&lang=ts"
export * from "./UsersManager.vue?vue&type=script&lang=ts"

import "./UsersManager.vue?vue&type=style&index=0&id=7c300492&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7c300492"

export default script